export default "__VITE_ASSET__BwJVm5tC__"